var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.timeline'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const yearsList = widget.querySelector('.timeline__years-list');
        if (!yearsList) return;

        const yearButtons = Array.from(widget.querySelectorAll('.timeline__year'));
        const eventPanels = Array.from(widget.querySelectorAll('.timeline__events-year'));
        const prevBtn = widget.querySelector('.timeline__years-arrow--prev');
        const nextBtn = widget.querySelector('.timeline__years-arrow--next');

        if (!yearButtons.length) return;

        // Scroll initially selected year into view without animation
        const initialIndex = yearButtons.findIndex(btn => btn.getAttribute('aria-selected') === 'true');
        if (initialIndex > 0) {
            scrollYearIntoView(yearButtons[initialIndex], yearsList, false);
        }

        const getCurrentIndex = () =>
            yearButtons.findIndex(btn => btn.getAttribute('aria-selected') === 'true');

        const selectYear = (index) => {
            const currentIndex = getCurrentIndex();

            if (currentIndex >= 0) {
                yearButtons[currentIndex].setAttribute('aria-selected', 'false');
            }
            yearButtons[index].setAttribute('aria-selected', 'true');

            const selectedYear = yearButtons[index].dataset.year;
            eventPanels.forEach(panel => {
                const isSelected = panel.dataset.year === selectedYear;
                panel.classList.toggle('d-block', isSelected);
                panel.classList.toggle('d-none', !isSelected);
            });

            prevBtn.disabled = index === 0;
            nextBtn.disabled = index === yearButtons.length - 1;

            scrollYearIntoView(yearButtons[index], yearsList);
        };

        const scrollYearIntoView = (yearBtn, container, smooth = true) => {
            const btnLeft = yearBtn.offsetLeft;
            const btnWidth = yearBtn.offsetWidth;
            const containerWidth = container.clientWidth;
            const targetScrollLeft = btnLeft - (containerWidth / 2) + (btnWidth / 2);
            container.scrollTo({ left: Math.max(0, targetScrollLeft), behavior: smooth ? 'smooth' : 'instant' });
        };

        yearButtons.forEach((btn, index) => {
            btn.addEventListener('click', () => selectYear(index));
        });

        prevBtn.addEventListener('click', () => {
            const currentIndex = getCurrentIndex();
            if (currentIndex > 0) selectYear(currentIndex - 1);
        });

        nextBtn.addEventListener('click', () => {
            const currentIndex = getCurrentIndex();
            if (currentIndex < yearButtons.length - 1) selectYear(currentIndex + 1);
        });

        widget.addEventListener('keydown', (e) => {
            if (!yearButtons.includes(document.activeElement)) return;

            const currentIndex = getCurrentIndex();

            if (e.key === 'ArrowLeft' && currentIndex > 0) {
                e.preventDefault();
                selectYear(currentIndex - 1);
                yearButtons[currentIndex - 1].focus();
            } else if (e.key === 'ArrowRight' && currentIndex < yearButtons.length - 1) {
                e.preventDefault();
                selectYear(currentIndex + 1);
                yearButtons[currentIndex + 1].focus();
            }
        });
    };

    return {
        initialize
    };

})();